import { createFeatureSelector, createSelector } from "@ngrx/store";
import { ListarComunicadosState } from "../reducers/listar-comunicados.reducer";

export const selectListarComunicadosState = createFeatureSelector<ListarComunicadosState>('listarComunicados');

export const selectDadosListarComunicados = createSelector(
  selectListarComunicadosState,
  (state: ListarComunicadosState) => state.response
);

export const selectListarComunicados = createSelector(
  selectListarComunicadosState,
  (state: ListarComunicadosState) => state
);

export const selectErrosListarComunicados = createSelector(
  selectListarComunicadosState,
  (state: ListarComunicadosState) => state.error
);